import React, { useEffect, useState } from "react";
import { GridToolbar } from "@material-ui/data-grid";
import { makeGETRequest } from "../../Api/api";
import { RouteComponentProps } from "react-router-dom";
import toastr from "toastr";
import { Box } from "@mui/material";
import moment from "moment";
import { DataGrid } from "@material-ui/data-grid";
import { Grid } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@mui/material/Skeleton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { WishListData } from "../RFQOrders/interfaces";

const UserWishlist: React.FC<RouteComponentProps> = () => {
    const [wishlist, setWishlist] = useState<WishListData[]>([]);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        makeGETRequest("admin/wishlist/list/")
            .then((resp) => {
                if (resp.status === 200) {
                    const data: WishListData[] = resp.data;
                    setWishlist(data);
                } else {
                    toastr.error("Something went wrong");
                }
            })
            .catch((error) => toastr.error(error))
            .finally(() => setLoading(false));
    }, []);

    const dataGridCells = [
        {
            field: "insertedAt",
            headerName: "Date",
            flex: 1,
            renderCell: (params: any) =>
                moment(params.row.insertedAt).format("DD MMM, YYYY HH:mm"),
        },
        { field: "isin", headerName: "ISIN", width: 150 },

        {
            field: "quoteSellPrice",
            headerName: "Sell Price",
            flex: 1,
        },
        {
            field: "quoteSellYield",
            headerName: "Sell Yield",
            flex: 1,
        },
        {
            field: "user_name",
            headerName: "Name",
            flex: 1,
            valueGetter: (params: any) => params.row.user?.name || "-",
        },
        {
            field: "user_email_id",
            headerName: "Email",
            flex: 1,
            valueGetter: (params: any) => params.row.user?.email_id || "-",
        },
        {
            field: "user_mobile_number",
            headerName: "Mob. No",
            flex: 1,
            valueGetter: (params: any) => params.row.user?.mobile_number || "-",
        },
        {
            field: "smest_id",
            headerName: "SMEST ID",
            flex: 1,
            valueGetter: (params: any) => params.row.user?.smest_id || "-",
        },
        {
            field: "isEmailSent",
            headerName: "Email Sent",
            flex: 1,
            renderCell: (params: any) => {
                return params.value === true ? (
                    <CheckCircleIcon style={{ color: "green" }} />
                ) : (
                    <CancelIcon style={{ color: "red" }} />
                );
            },
        },
    ];

    return (
        <Grid className="QuotesDataGrid">
            <Paper>
                <Grid style={{ margin: "20px 0", padding: "0 20px" }}>
                    <Grid container alignItems="center" spacing={3}>
                        <Grid item xs>
                            <div style={{ fontSize: "36px", float: "left" }}>
                                User Wishlist
                            </div>
                        </Grid>
                    </Grid>
                </Grid>

                <Box
                    sx={{
                        height: "100vh",
                        width: "100%",
                        px: [2, 10],
                        "& .MuiDataGrid-columnHeaderTitle": {
                            fontWeight: "bold",
                        },
                    }}
                >
                    {!loading ? (
                        <DataGrid
                            pagination
                            components={{ Toolbar: GridToolbar }}
                            rows={wishlist}
                            columns={dataGridCells}
                            getRowId={(row) => row.uuid}
                        />
                    ) : (
                        <Box>
                            {[1, 2, 3, 4, 5].map((i) => (
                                <Skeleton key={i} height={50} animation="wave" />
                            ))}
                        </Box>
                    )}
                </Box>
            </Paper>
        </Grid>
    );
};

export default UserWishlist;
